import i18n, { applyApiTranslations, extendMessages, syncMomentLocale } from "../i18n";
import localesData from "../data/locales.json";

const keyFromText = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '')
    .split(' ')
    .filter(Boolean)
    .map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}

const TranslationHelper = {
  getLocales() {
    let locales = this.$store.getters["translation/translationLanguageiso"];
    if (locales.length === 0) {
      locales = this.$store.getters["translation/translatedLanguages"];
    }

    return locales.map((locale) => {
      const localeData = localesData.find((l) => l.code === locale);
      return {
        code: localeData.code,
        title: localeData.nativeName,
      };
    });
  },
  getFacilityName(name) {
    const key = "facilities." + keyFromText(name);
    const translation = i18n.t(key);

    return translation === key ? name : translation;
  },
  getPropertyTypeName(name) {
    const key = "propertyTypes." + keyFromText(name);
    const translation = i18n.t(key);

    return translation === key ? name : translation;
  },
  getTextTranslation(page, text) {
    const key = `${page}.${keyFromText(text)}`;
    const translation = i18n.t(key);

    return translation === key ? text : translation;
  },
  async updateTranslations(router, language = "en", force = false) {
    this.$store = this.$store ?? router.app.$store;

    let data = await this.$store.getters["translation/getLanguages"];
    if (!data || force) {
      data = await this.$store.dispatch("translation/getTranslate", {
        language,
        force,
      });
    }

    this.$store.commit("translation/getTranslation", { ...data });
    if (data?.translations) {
      applyApiTranslations(data.translations);
    } else {
      const locales = require.context(
        "../i18n/locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
      );
      locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          i18n.setLocaleMessage(locale, extendMessages(locales(key)));
        }
      });
    }

    i18n.locale = language;
    syncMomentLocale(language);
  },
};

export default TranslationHelper;
